<article class="avatar-upload">
  <div class="avatar-upload-content">
      <span class="modal-close" (click)="onCancel()" title="Close">✕</span>
    <header>
      <core-title-section
      [title]="'Upload profile photo'"
      [description]="''"
      ></core-title-section>
    </header>

    <core-files-upload
    [multiple]="false"
    (response)="upload($event)"
    (onUploading)="uploading($event)"
    ></core-files-upload>
  </div>

</article>
